import { useEffect } from "react";
import { setDocumentTitle } from "@/lib/documentTitle";
import { K1DashboardProvider } from "@/features/K1Dashboard/context/K1DashboardProvider";
import PositionsIssuersView from "@/features/K1Dashboard/views/PositionsIssuersView";

export default function K1PositionsIssuers() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Positions-Issuers");
  }, []);

  return (
    <K1DashboardProvider>
      <main className="min-h-0 flex flex-1 flex-col overflow-auto bg-white p-5">
        <PositionsIssuersView />
      </main>
    </K1DashboardProvider>
  );
}
